import { useMedia } from "react-use";

export const useDesktopDown = () => useMedia('(max-width: 1023px)')
export const useTabletDown = () => useMedia('(max-width: 767px)')